import { RecordOf } from '@opengov/compose-app/immutable';

import { ICurrentOrLegacySavedView } from '@opengov/reporting-legacy-module';

export const CurrentOrLegacySavedView = RecordOf<ICurrentOrLegacySavedView>({
  id: null,
  reportId: null,
  legacySavedViewId: null,
  description: null,
  url: null,
  name: null,
  position: null
});
